import {
  type ResultOf,
  type VariablesOf,
} from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

import { useBrandAccountId } from './useBrandAccountId'

const document = graphql(`
  mutation CreateSurveyPage_CreateSurvey(
    $brandAccountId: String!
    $title: String!
    $metadata: SurveyMetadataInput
  ) {
    createSurvey(
      brandAccountId: $brandAccountId
      title: $title
      metadataInput: $metadata
    ) {
      id
    }
  }
`)
type Data = ResultOf<typeof document>
type Variables = VariablesOf<typeof document>

export const useCreateSurveyMutation = (
  options: Omit<
    UseMutationOptions<
      Data,
      unknown,
      Omit<Variables, 'brandAccountId'>,
      unknown
    >,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()
  const brandAccountId = useBrandAccountId()

  return useMutation({
    mutationFn: (variables) =>
      graphQLRequest({ document, variables: { ...variables, brandAccountId } }),
    ...options,
  })
}
